import { HHTextField } from '@hinge-health/react-component-library';
import Autocomplete from '@mui/material/Autocomplete';
import { Controller } from 'react-hook-form';
import { ClientFilterProps, StatusFilterLabelText } from './filter-types';

export const ClientFilter = ({
  control,
  name = 'clients',
  clients,
  hasError = false,
  variant = 'standard',
  sx = { minWidth: 230, maxWidth: 230 },
  label = StatusFilterLabelText.CLIENT,
  loading = false,
}: ClientFilterProps): JSX.Element => (
  <Controller
    control={control}
    name={name}
    render={({ field: { onChange, value } }): JSX.Element => (
      <Autocomplete
        multiple
        id="clients-select"
        options={!hasError ? clients : []}
        disabled={!!hasError || loading}
        getOptionLabel={(option): string => option.name}
        size="small"
        sx={sx}
        limitTags={1}
        blurOnSelect={true}
        onChange={(_, newValue): void => onChange(newValue)}
        value={value}
        renderInput={(params): JSX.Element => (
          <HHTextField
            {...params}
            hhVariant="variant-bypass"
            variant={variant}
            label={label}
            error={!!hasError}
            helperText={hasError ? 'clients unavailable' : ''}
          />
        )}
      />
    )}
  />
);
